import React, {Component} from 'react';
import PropTypes from 'prop-types';
import media from '../MediaQueries.js';
import styled from 'styled-components';

import { Collapse, Input, InputGroup, InputGroupButton, FormFeedback, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem,
        NavLink, Container, Row, Col, Jumbotron, Button, ButtonGroup, Dropdown, DropdownToggle } from 'reactstrap';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router'

import MyNavbar from '../components/MyNavbar.js';
import Hero from '../components/Hero.js';
import Featured from '../components/Featured.js';
import CandleInfo from '../components/CandleInfo.js';
import Story from '../components/Story.js';
import Connect from '../components/Connect.js';
import FooterHelp from '../components/FooterHelp.js';
import FooterBottom from '../components/FooterBottom.js';
import Modal from 'react-modal';

export default class Home extends Component  {
  static propTypes = {
    products: PropTypes.array.isRequired,
    scrollToSection: PropTypes.func.isRequired,
    setHomeIsMounted: PropTypes.func.isRequired,
    windowWidth: PropTypes.number.isRequired,
    addItemToCart: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props);

    this.state = {

    };
  }

  componentDidMount() { this.props.setHomeIsMounted(); }
  componentWillUnmount() { this.props.setHomeIsMounted(); }

  render () {
  	return (
		<div>
			<Hero />

			{/*this.props.products.length > 0 ? <Featured addItemToCart={this.props.addItemToCart} products={this.props.products} /> : ""*/}
			<CandleInfo />
			<Story />
		</div>
  	);
  }
};


// WEBPACK FOOTER //
// ./src/pages/Home.js